module.exports = __webpack_public_path__ + "static/bitcoin-mag-logo-13463c1c929148a2066a5da69f852525.png";